import styled from 'styled-components';
import { styles } from '@utils';
import sharedStyles from '@repo/ui-components/styles';

const PageHeading = styled.h1`
  margin: ${props =>
    props.outside
      ? '2rem 0 1.2rem'
      : `0 0 ${sharedStyles.spacing['spacing-2xs']}`};
  color: ${props => (props.color ? props.color : styles.colors.gray[500])};
  text-transform: uppercase;
  font-weight: ${sharedStyles.fontWeight.bold};
`;

const PageSubHeading = styled.h2`
  color: white;
  text-transform: uppercase;
  font-weight: 700;
`;

export { PageHeading, PageSubHeading };
